// extracted by mini-css-extract-plugin
export default {"text":"recover-account_text__Mxqso","ConfirmRecoverButton":"recover-account_ConfirmRecoverButton__QuY23","PointerCursor":"recover-account_PointerCursor__MoV2D"};